import type {
  SkeletonItemSlots as SkeletonItemBaseSlots,
  SkeletonItemBaseProps,
  SkeletonItemBaseState,
} from '@fluentui/react-skeleton';

/**
 * SkeletonItem component slots
 */
export type SkeletonItemSlots = SkeletonItemBaseSlots;

/**
 * SkeletonItem component props
 */
export type SkeletonItemProps = SkeletonItemBaseProps;

/**
 * SkeletonItem component state
 */
export type SkeletonItemState = SkeletonItemBaseState;
